/**
 * Modals/toasts portal here so they inherit from `#customer-app-root` typography
 * and stacking context inside the SPA — not bare `document.body` (Shopify theme
 * global `button`/type/color rules paint those nodes first otherwise).
 */
export function fgPortalMount(): HTMLElement | null {
  if (typeof document === "undefined") return null;
  return document.getElementById("customer-app-root");
}
